import * as Yup from 'yup';

const zoneSchema = Yup.object().shape({
  Zone_ID: Yup.number(),
  Zone_name: Yup.string().required('Zone name is required'),
  Zone_description: Yup.string().required('Zone description is required'),
  Site_ID: Yup.number().typeError('Site ID is required').required('Site ID is required'),
  Risk_level: Yup.string().required('Risk level is required'),
});


export const validateZone = (zoneData) => {
  return zoneSchema.validate(zoneData, { abortEarly: false });
};

export default zoneSchema;
